var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "white"
    },
    d: "M481.429 332.892c-26.337-26.357-62.882-37.523-109.815-24.945L204.256 140.419l2.212-8.364c9.639-36.166-.776-75.041-27.172-101.437C152.42 3.721 114.212-6.148 78.077 3.778a14.996 14.996 0 0 0-10.529 10.631 15.001 15.001 0 0 0 3.909 14.438l40.297 40.297c11.781 11.81 11.666 30.724.029 42.392-11.545 11.576-30.951 11.558-42.45.029L29.028 71.257a14.993 14.993 0 0 0-14.454-3.891A14.993 14.993 0 0 0 3.962 77.917c-9.781 35.738-.159 74.183 26.846 101.188 26.326 26.345 62.825 37.551 109.786 24.946l167.371 167.528c-12.49 46.919-1.716 83.11 24.975 109.801 26.91 26.93 65.136 36.726 101.192 26.833a14.999 14.999 0 0 0 10.532-10.631 14.998 14.998 0 0 0-3.909-14.44l-40.288-40.288c-11.781-11.81-11.666-30.726-.029-42.392 11.689-11.629 31.052-11.444 42.45-.015l40.308 40.297a14.996 14.996 0 0 0 14.453 3.889 14.995 14.995 0 0 0 10.611-10.549c9.781-35.732.161-74.187-26.831-101.192z",
    fill: "#000000",
    "data-original": "#000000",
    className: ""
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.551 266.584 17.559 409.594c-23.401 23.401-23.401 61.455 0 84.855 23.401 23.401 61.455 23.401 84.855 0l142.989-143.006-84.852-84.859zM88.322 447.898c-5.86 5.86-15.35 5.86-21.21 0-5.859-5.859-5.859-15.351 0-21.21l90.98-90.997c5.859-5.859 15.352-5.859 21.21 0 5.859 5.859 5.859 15.351 0 21.21l-90.98 90.997zM507.596 30.253 481.737 4.394a15 15 0 0 0-18.322-2.258l-79.547 47.723c-8.37 5.021-9.791 16.568-2.891 23.469l6.332 6.33-100.98 100.567 42.435 42.435 100.98-100.567 8.919 8.921c6.901 6.899 18.449 5.479 23.469-2.891l47.723-79.547a15.004 15.004 0 0 0-2.259-18.323z",
    fill: "#FFFFFF",
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport1);
export default __webpack_public_path__ + "static/media/support_1.1272d4e973c7c083e10fd6913b598c82.svg";
export { ForwardRef as ReactComponent };